<template>
    <div>
        <!-- Modal Alterar Data -->
        <div class="modal fade" id="alterarMarcPlanoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Operadora/Plano</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="marcacao">
                            <div class="lead">
                                {{ marcacao.nome_paciente }}
                            </div>
                            <div>
                                <span class="badge badge-info" v-if="dados && dados.lista">{{ dados.lista.length }}</span>
                            </div>
                        </div>

                        <div class="form-row" v-if="dados && dados.lista">
                            <div class="col col-12" :class="( fl_particular || fl_sus || !novo_plano ) ? '' : 'col-md-6'">
                                <az-input 
                                    sizing="sm"
                                    label="Nova: Operadora / Plano" 
                                    type="autocomplete" 
                                    optionsMode="aql" 
                                    :optionsParm="{ atendimento: true }"
                                    optionsName="planos.atendimento"
                                    service="planos.index" 
                                    optionsDisplay="search"
                                    :optionsSync="false"
                                    v-model="novo_plano"
                                    required 
                                    :validate="validate" />
                            </div>

                            <div class="col col-12 col-md-3" v-if="!fl_particular && !fl_sus && novo_plano">
                                <az-input 
                                    sizing="sm"
                                    label="Número da Matrícula" 
                                    type="text" 
                                    v-model="nova_matricula"
                                    :validate="validate">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3" v-if="!fl_particular && !fl_sus && novo_plano">
                                <az-input 
                                    sizing="sm"
                                    label="Vencimento da Matrícula" 
                                    type="date"
                                    v-model="nova_validade"
                                    :validate="validate"/>
                                    <!-- :rules="['futuro']" -->
                            </div>
                        </div>

                        <table class="table table-sm table-hover small mt-3" v-if="dados && dados.lista && dados.lista.length">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>#</th>
                                    <th>Data/Hora</th>
                                    <th>Operadora</th>
                                    <th>Procedimento</th>
                                    <th>Profissional</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, iix) in dados.lista" :key="iix">
                                    <td>
                                        <input type="checkbox" v-model="item.ch_estado_marcacao">
                                    </td>
                                    <td>
                                        <template v-if="item.id_atendimento">#{{ item.id_atendimento }}</template>
                                        <span v-else class="text-muted">M{{ item.id_marcacao }}</span>
                                    </td>
                                    <td>{{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.slice(11,16) }}</td>
                                    <td>{{ item.plano ? item.plano.search : '' }}</td>
                                    <td>{{ item.procedimento ? item.procedimento.search : '' }}</td>
                                    <td>{{ item.medico ? item.medico.search : '' }}</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                        <br><br><br><br><br><br><br><br><br><br>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            dados: null, 
            marcacao: null, 
            validate: false, 
            novo_plano: null, 
            nova_matricula: "", 
            nova_validade: "", 
        }
    },

    components: {
        AzInput, 
        AzSubmit
    },

    computed: { 
        fl_sus: function() { 
            return this.novo_plano && this.novo_plano.operadora && this.novo_plano.operadora.fl_sus;
        },
        fl_particular: function () { 
            return this.novo_plano 
                && this.novo_plano.id_operadora == 1 
                && !this.novo_plano.fl_validade_particular
        }
    },

    methods: { 
        abrir(marcacao) { 
            
            this.novo_plano = null; 
            this.nova_matricula = "";
            this.nova_validade = "";
            this.marcacao = null; 
            this.validate = false; 

            console.log('alter_plano', marcacao);

            this.$util.load(this, { 
                service: 'marcacoes', 
                func: 'lista_dia',
                parms: { 
                    id_paciente: marcacao.id_paciente, 
                    id_cadastro_temporario: marcacao.id_cadastro_temporario,
                    inicio: marcacao.dt_inicio.slice(0,10),
                    fim: marcacao.dt_inicio.slice(0,10),  
                },
                loadTo: res => { 
                    this.dados = res;   

                    if ( res.lista && res.lista.length ) { 
                        this.marcacao = res.lista[0];
                    }
                }
            });

            $('#alterarMarcPlanoModal').modal('show');

        },

        atualizar() { 
            let lista = this.dados && this.dados.lista 
                ? this.dados.lista.filter(item => !!item.ch_estado_marcacao)
                    .map(item => item.id_marcacao)
                : [];

            if ( !lista.length ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Atenção',
                    detail: 'Nenhum item selecionado.',
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'alterar_plano_lista', 
                dados: { 
                    lista: lista, 
                    novo_plano: this.novo_plano ? this.novo_plano.id_plano : null,
                    nova_matricula: this.nova_matricula,
                    nova_validade: this.nova_validade
                },
                modal: 'alterarMarcPlanoModal',
                callback: () => { 
                    this.$emit('refresh')
                }
            });
        }
    }
}
</script>
